<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div
		id="data-list-list-view"
		class="data-list-container"
	>
		<vs-alert
			title="Hiba!"
			active="true"
			color="danger"
			v-if="errorMessage"
		>
			{{ errorMessage }}
		</vs-alert>
		<!-- Subtransaction modal -->
		<vs-popup
			class="holamundo"
			title="Alügylet létrehozása"
			:active.sync="transactionTypeModal"
			v-if="searchData"
		>
			<form v-on:submit.prevent="save()">
				<div class="vs-row">
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>

						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>

							<v-select
								v-if="searchData.transactionTypes"
								class="w-full"
								:clearable="false"
								v-model="subTransactionTypeId"
								:options="searchData.transactionTypes"
								:reduce="type => type.id"
								label="name"/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="saveSubTransaction()"
							>Mentés</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<!-- Subransaction modal END -->
		<!-- Print modal -->
		<vs-popup
			class="holamundo"
			title="Excel generálása"
			:active.sync="printModal"
		>
			<form v-on:submit.prevent="printData(printedTransaction)">
				<div class="vs-row">
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>

						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<vs-textarea
								label="Helyszíni szemle előtti akadály"
								v-model="printedTransaction.szemleElott"
							/>

						</vs-col>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<vs-textarea
								label="Helyszíni szemle utáni akadály"
								v-model="printedTransaction.szemleUtan"
							/>

						</vs-col>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<vs-textarea
								label="Megjegyzés a szemléről"
								v-model="printedTransaction.szemleMegjegyzes"
							/>

						</vs-col>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<vs-textarea
								label="Megjegyzés"
								v-model="printedTransaction.megjegyzes"
							/>

						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="printData(printedTransaction)"
							>Excel generálás</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<!-- Print modal END -->
		<!-- Search modal -->
		<vs-popup
			class="holamundo"
			title="Keresés"
			:active.sync="searchModal"
		>
			<form v-on:submit.prevent="filterTransaction(search)">
				<div class="vs-row">
						<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<vs-input
								label="Kulcsszó"
								v-model="search.q"
							/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="filterTransactions(search)"
							>Keresés</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<!-- Search modal END -->
		<!-- Close transaction modal -->
		<vs-popup
			class="holamundo"
			title="Ügylet lezárása"
			:active.sync="closeTransactionModal"
		>
			<form v-on:submit.prevent="save()">
				<div class="vs-row">
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>

						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>

							<v-select
								v-if="searchData"
								class="w-full"
								:clearable="false"
								v-model="closeReason"
								:options="searchData.closeReason"
								:reduce="reason => reason.value"
								label="label"/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="confirmCloseTransaction()"
							>Mentés</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<!-- Close transaction modal END -->
		<!-- Add phase modal -->
		<vs-popup
			class="holamundo"
			title="Feladat hozzáadása"
			:active.sync="addPhaseModal"
			v-if="phases && workers"
		>
			<form v-on:submit.prevent="save()">
				<div class="vs-row">

					<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<label class="vs-select--label" for="">Feladat</label>
							<v-select
								v-if="phases"
								class="w-full"
								:clearable="false"
								v-model="newPhase.phaseId"
								:options="phases"
								:reduce="phase => phase.id"
								label="name"/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<label class="vs-select--label" for="">Dolgozó</label>
							<v-select
								v-if="workers"
								class="w-full"
								:clearable="false"
								v-model="newPhase.userId"
								:options="workers"
								:reduce="worker => worker.id"
								label="fullName"/>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<small class="date-label">Határidő</small>
							<datepicker
								:full-month-name=true
								:monday-first=true
								:language="langHu"
								:format="customFormatter"
								name="deadline"
								v-model="newPhase.deadline"
							></datepicker>

						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="12"
							class="p-2"
						>
							<vs-textarea
								label="Megjegyzés"
								v-model="newPhase.comment"
							/>

						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="savePhase()"
							>Mentés</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<!-- Add phase modal END -->
		<vx-card>
			<div class="flex flex-row">
				<vs-button
					color="primary"
					size="large"
					type="flat"
					icon="icon-arrow-left"
					icon-pack="feather"
					@click="$router.go(-1)"
				></vs-button>
				<h4 class="mt-3">
					Ügyletek
				</h4>
				<div class="rounded-lg cursor-pointer items-center justify-center right-button inline-buttons">
					<vs-input
							placeholder="Kulcsszó"
							v-model="search.q"
							class="mr-2"
							v-on:keyup="filterTransactions(search)"
							autocomplete="none"
						/>
					<v-select
						v-if="searchData"
							style="width: 120px"
							:clearable="false"
							class="mr-2 mt-0"
							v-model="search.itemsPerPage"
							:options="searchData.itemsPerPage"
							label="label"
							:reduce="itemsPerPage => itemsPerPage.value"
							v-on:input="filterTransactions(search)"/>
					<vx-tooltip
						text="Keresés">
						<vs-button
							class="btn-drop mr-2"
							type="border"
							size="medium"
							icon-pack="feather"
							icon="icon-search"
							color="grey"
							@click.stop="searchModalOpen()"
						></vs-button>
					</vx-tooltip>
					<vx-tooltip
						text="Frissítés">
						<vs-button
							class="btn-drop mr-2"
							type="border"
							size="medium"
							icon-pack="feather"
							icon="icon-refresh-cw"
							color="grey"
							@click.stop="filterTransactions(search)"
						></vs-button>
					</vx-tooltip>
					<vx-tooltip
						text="Keresés törlése">
						<vs-button
							class="btn-drop mr-2"
							type="border"
							size="medium"
							icon-pack="feather"
							icon="icon-x"
							color="grey"
							@click.stop="fetch()"
						></vs-button>
					</vx-tooltip>
					<vs-dropdown
						class="cursor-pointer mr-2"
						vs-custom-content
						vs-trigger-click
					>
						<vs-button
							class="btn-drop"
							color="grey"
							type="border"
							icon-pack="feather"
							icon="icon-more-vertical"
							size="medium"
						></vs-button>
						<vs-dropdown-menu class="pt-3 list-more">
							<ul style="min-width: 9rem">
								<li
									class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
									@click.stop="multipleSelect = !multipleSelect"
								>
									<span
										class="ml-2"
										v-if="multipleSelect"
									>Kijelölés megszüntetése</span>
									<span
										class="ml-2"
										v-if="!multipleSelect"
									>Több kijelölése</span>
								</li>
								<li
									v-if="multipleSelect"
									class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
									@click.stop="closeTransactions()"
								>
									<span class="ml-2">Kijelöltek lezárása ({{ selectedTransactions.length }} db)</span>
								</li>
								<li
									v-if="multipleSelect"
									class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
									@click.stop="addPhaseMultiple()"
								>
									<span class="ml-2">Feladat hozzáadása ({{ selectedTransactions.length }} db)</span>
								</li>
							</ul>
						</vs-dropdown-menu>
					</vs-dropdown>

					<vs-button
						color="primary"
						size="medium"
						class="pull-right btn-add-new"
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						@click="addNewData"
					>
						Új ügylet
					</vs-button>
				</div>
			</div>
			<vs-table
				v-if="transactions"
				:hoverFlat="true"
				stripe
				:notSpacer="true"
				:data="transactions"
				noDataText="Nincs találat"
			>

				<template slot="thead">
					<vs-th ></vs-th>

					<vs-th v-if="multipleSelect">
						<vx-tooltip
								text="Mind kijelölése"
							>
						<vs-checkbox
								v-model="selectAllTransactions"
								value="on"
							></vs-checkbox>
						</vx-tooltip>
					</vs-th>
					<vs-th>
						<div @click.stop="orderTransactions('transactions.transaction_number')">
							Ügyszám
						</div>
						<span class="sort-th" @click.stop="orderTransactions('transactions.transaction_number')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'transactions.transaction_number'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'transactions.transaction_number'"
							>expand_more</em>
						</span>
					</vs-th>
					<vs-th>
						<div @click.stop="orderTransactions('transactions.task_code')">
							Feladat kód
						</div>
						<span class="sort-th" @click.stop="orderTransactions('transactions.task_code')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'transactions.task_code'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'transactions.task_code'"
							>expand_more</em>
						</span>
					</vs-th>
					<vs-th>
						<div @click.stop="orderTransactions('customers.name')">
							Megrendelő
						</div>
						<span class="sort-th" @click.stop="orderTransactions('customers.name')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'customers.name'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'customers.name'"
							>expand_more</em>
						</span>
					</vs-th>
					<vs-th>
						<div @click.stop="orderTransactions('clients.name')">
							Ügyfél
						</div>
						<span class="sort-th" @click.stop="orderTransactions('clients.name')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'clients.name'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'clients.name'"
							>expand_more</em>
						</span>
					</vs-th>
					<vs-th>
						<div @click.stop="orderTransactions('properties.city')">
							Ingatlan
						</div>
						<span class="sort-th" @click.stop="orderTransactions('properties.city')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'properties.city'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'properties.city'"
							>expand_more</em>
						</span>
					</vs-th>
					<vs-th>
						<div @click.stop="orderTransactions('transaction_types.name')">
							Típus
						</div>
						<span class="sort-th" @click.stop="orderTransactions('transaction_types.name')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'transaction_types.name'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'transaction_types.name'"
							>expand_more</em>
						</span>
					</vs-th>
					<!-- <vs-th sort-key="status">Státusz</vs-th> -->
					<vs-th>
						<div @click.stop="orderTransactions('transaction_types.name')">
							Státusz
						</div>
						<span class="sort-th" @click.stop="orderTransactions('transaction_types.name')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'transaction_types.name'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'transaction_types.name'"
							>expand_more</em>
						</span>
					</vs-th>
					<vs-th>
						<div>
							Számla
						</div>
					</vs-th>
					<vs-th>
						<div @click.stop="orderTransactions('transactions.order_date')">
							Megrendelés dátuma
						</div>
						<span class="sort-th" @click.stop="orderTransactions('transactions.order_date')">
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'desc' || this.search.sortBy != 'transactions.order_date'"
							>expand_less</em>
							<em
								class="vs-icon notranslate icon-scale th-sort-icon material-icons null"
								v-if="this.search.sortDir == 'asc' || this.search.sortBy != 'transactions.order_date'"
							>expand_more</em>
						</span>
					</vs-th>
					<vs-th></vs-th>
					<vs-th></vs-th>
				</template>

				<div
					slot="header"
					class="flex items-center flex-grow justify-between"
				>
					<div class="flex items-center data-list-btn-container flex-wrap">
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 150px"
						>
							<vs-input
								label-placeholder="Megrendelői ügyszám"
								v-model="search.transactionNumber"
								class="w-full"
								name="transactionNumber"
								v-on:keyup="filterTransactions(search)"
								autocomplete="none"
							/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 100px"
						>
							<vs-input
								label-placeholder="Feladat kód"
								v-model="search.taskCode"
								class="w-full"
								name="taskCode"
								v-on:keyup="filterTransactions(search)"
								autocomplete="none"
							/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 300px"
						>
							<label class="vs-select--label" for="">Megrendelő</label>
							<v-select
								class="w-full"
								v-model="search.customer"
								:options="searchData.customers"
								placeholder="Mind"
								:reduce="customer => customer.id"
								label="displayName"
								v-on:input="filterTransactions(search)"/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 180px"
						>
							<vs-input
								label-placeholder="Ügyfél"
								v-model="search.client"
								class="w-full"
								name="client"
								v-on:keyup="filterTransactions(search)"
								autocomplete="none"
							/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 180px"
						>
							<vs-input
								label-placeholder="Ingatlan"
								v-model="search.property"
								class="w-full"
								name="property"
								v-on:keyup="filterTransactions(search)"
								autocomplete="none"
							/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 100px"
						>
							<vs-input
								label-placeholder="HRSZ"
								v-model="search.parcelNumber"
								class="w-full"
								name="property"
								v-on:keyup="filterTransactions(search)"
								autocomplete="none"
							/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 200px"
						>
							<label class="vs-select--label" for="">Típus</label>
							<v-select
								class="w-full"
								v-model="search.transactionType"
								:options="searchData.transactionTypes"
								label="label"
								placeholder="Mind"
								:reduce="transactionType => transactionType.id"
								v-on:input="filterTransactions(search)"/>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 420px"
						>
							<label class="vs-select--label" for="">Feladat/státusz</label>
							<v-select
								class="w-full"
								v-model="search.transactionPhase"
								:options="searchData.transactionPhases"
								label="text"
								placeholder="Mind"
								:reduce="transactionPhase => transactionPhase.value"
								v-on:input="filterTransactions(search)"/>
						</div>

						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 100px"
						>
							<label class="vs-select--label" for="">Kezdődátum</label>
							<datepicker
								:full-month-name=true
								:monday-first=true
								:language="langHu"
								:format="customFormatter"
								name="deadline"
								v-model="search.startDate"
								v-on:input="filterDates(search)"
							></datepicker>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 100px"
						>
							<label class="vs-select--label" for="">Végdátum</label>
							<datepicker
								:full-month-name=true
								:monday-first=true
								:language="langHu"
								:format="customFormatter"
								name="deadline"
								v-model="search.endDate"
								v-on:input="filterDates(search)"
							></datepicker>
						</div>
						<div
							class="mr-4 rounded-lg cursor-pointer items-center justify-center"
							v-if="searchData"
							style="width: 300px"
						>
							<label class="vs-select--label" for="">Csak a hiányos ügyletek megjelenítése</label>
							<vs-switch v-model="showOnlyDeficient" />
						</div>

					</div>
				</div>

				<template v-cloak>
					<vs-tr>
						<vs-td></vs-td>
						<vs-td></vs-td>
						<vs-td v-if="multipleSelect"></vs-td>
						<vs-td>
							<v-select
								:multiple="true"
								height="auto"
								:hide-selected="true"
								:small-chips="true"
								class="w-full taskcode-select select-size-sm"
								v-model="search.taskCodes"
								:options="searchData.taskCodes"
								placeholder="Mind"
								:reduce="taskCode => taskCode.task_code"
								label="task_code"
								v-on:input="filterTransactions(search)"/>
						</vs-td>
						<vs-td>
							<v-select
								:multiple="true"
								height="auto"
								:hide-selected="true"
								:small-chips="true"
								class="w-full customer-select select-size-sm"
								v-model="search.customers"
								:options="searchData.customers"
								placeholder="Mind"
								:reduce="customer => customer.id"
								label="displayName"
								v-on:input="filterTransactions(search)"/>
						</vs-td>
						<vs-td></vs-td>
						<vs-td>
							<v-select
								:multiple="true"
								height="auto"
								:hide-selected="true"
								:small-chips="true"
								class="w-full customer-select select-size-sm"
								v-model="search.cities"
								:options="searchData.cities"
								placeholder="Mind"
								:reduce="city => city.city"
								label="city"
								v-on:input="filterTransactions(search)"/>
						</vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
						<vs-td></vs-td>
					</vs-tr>
				</template>

				<template v-for="(transaction, indextr) in transactions">
					
					<vs-tr
						v-bind:key="indextr">
						<vs-td class="expand-column">
							<vs-button
								v-if="transactions[indextr].subTransactions.length > 0"
								color="primary"
								type="flat"
								size="small"
								icon-pack="feather"
								:icon="transactions[indextr].id == expandedId ? 'icon-chevron-down' : 'icon-chevron-right'"
								@click="expandSubRows(transactions[indextr].id)"
							></vs-button>
						</vs-td>
						<vs-td v-if="multipleSelect">
							<vs-checkbox
								v-model="selectedTransactions"
								:vs-value="transactions[indextr].id"
							></vs-checkbox>
						</vs-td>
						<vs-td :data="transactions[indextr].transactionNumber ? transactions[indextr].transactionNumber : ''">
							<router-link
								v-if="!transactions[indextr].locked || currentUser.id == transactions[indextr].lockedBy.id"
								:to="/ugylet/ + transactions[indextr].id"
							>{{ transactions[indextr].transactionNumber }}</router-link>
							<span v-if="transactions[indextr].locked && currentUser.id != transactions[indextr].lockedBy.id">{{ transactions[indextr].transactionNumber }}</span>
						</vs-td>
						<vs-td :data="transactions[indextr].taskCode ? transactions[indextr].taskCode : ''">
							{{ transactions[indextr].taskCode ? transactions[indextr].taskCode : '' }}
						</vs-td>
						<vs-td :data="transactions[indextr].customer ? transactions[indextr].customer.displayName : ''">
							<router-link :to="/megrendelo/ + transactions[indextr].customer.id">{{ transactions[indextr].customer ? transactions[indextr].customer.displayName : '' }}</router-link>
							<br>
							<small>
								{{ transactions[indextr].customer ? transactions[indextr].customer.fullAddress  : '' }}
							</small>
							<br>
							<small>
								{{ transactions[indextr].contact ? '(' + transactions[indextr].contact.fullName + ')' : '' }}
							</small>
						</vs-td>
						<vs-td 
							style="max-width:200px"
							:data="transactions[indextr].client ? transactions[indextr].client.displayName : ''">
							{{ transactions[indextr].client ? transactions[indextr].client.displayName : '-' }}
						</vs-td>
						<vs-td
							style="max-width:200px"
							:data="transactions[indextr].property ? transactions[indextr].property.fullAddress : ''">
							{{ transactions[indextr].property ? transactions[indextr].property.fullAddress : '' }}
							<br>
							<small>
								HRSZ: {{ transactions[indextr].property ? transactions[indextr].property.parcelNumber : '' }}
							</small>

						</vs-td>
						<vs-td :data="transactions[indextr].transactionType ? transactions[indextr].transactionType.name : ''">
							{{ transactions[indextr].transactionType.parent ? transactions[indextr].transactionType.parent.name + ' / ' + transactions[indextr].transactionType.name : transactions[indextr].transactionType.name }}
							<br>
							<br>
							<small>
								<i>{{ transactions[indextr].typeComment ? transactions[indextr].typeComment : '' }}</i>
							</small>
						</vs-td>
						<vs-td :data="transactions[indextr].lastPhase ? transactions[indextr].lastPhase.phase.name : ''">
							<vs-chip
								v-bind:style="{backgroundColor: transaction.lastPhase.phase.bgColor }"
								v-bind:class="{ darkText: transaction.lastPhase.phase.bgColor == '#fff', darkBorder: transaction.lastPhase.phase.bgColor == '#fff' }"
								color="getStatusColor(subTransaction.lastPhase ? subTransaction.lastPhase.status : '')"
								v-if="transactions[indextr].lastPhase"
							>
								{{ (transactions[indextr].lastPhase.phase.id != 1 && transactions[indextr].lastPhase.phase.id != 7) ? transactions[indextr].lastPhase.phase.name + ' - ' + transactions[indextr].lastPhase.statusText : (transactions[indextr].lastPhase.phase.id == 7 ? transactions[indextr].lastPhase.phase.name + ' ('  + transactions[indextr].lastPhase.statusText + ')' : transactions[indextr].lastPhase.phase.name) }}
								{{ transactions[indextr].lastPhase.obstacles.length > 0 ? ' - Akadályozott' : '' }}
							</vs-chip>
							<br>
							<br>
							<small>
								{{ (transactions[indextr].lastPhase && transactions[indextr].lastPhase.finishWorker) ? 'Dolgozó: ' + transactions[indextr].lastPhase.finishWorker.fullName : '' }}
							</small>
						</vs-td>
						<vs-td>
							Sorszám: {{ transactions[indextr].invoiceNumber ? transactions[indextr].invoiceNumber : '-' }} <br>
							Díj: {{ transactions[indextr].price ? transactions[indextr].price + 'Ft' : '-' }} 
						</vs-td>
						<vs-td :data="transactions[indextr].orderDate">
							{{ transactions[indextr].orderDate ? transactions[indextr].orderDate : '' }} (+{{ transactions[indextr].orderDiff ? transactions[indextr].orderDiff : '' }})
							<br>
							<small>
								<i>Határidő: {{ transactions[indextr].dueDate ? transactions[indextr].dueDate : '' }}</i>
							</small>
						</vs-td>
						<vs-td>
							<vx-tooltip
									text="Hiányzó adat"
									v-if="transactions[indextr].isDeficient" 
								>
								<feather-icon 
									icon="AlertCircleIcon" 
									svgClasses="stroke-current text-warning" />
							</vx-tooltip>
							<feather-icon 
								v-if="!transactions[indextr].isDeficient" 
								icon="CheckIcon" 
								svgClasses="stroke-current text-success" />
						</vs-td>
						<vs-td>
							<div class="flex pull-right">
								<vx-tooltip
									text="Módosítás"
									v-if="!transactions[indextr].locked || currentUser.id == transactions[indextr].lockedBy.id"
								>
									<vs-button
										class="btn-drop mr-2"
										type="border"
										icon-pack="feather"
										icon="icon-edit"
										size="medium"
										color="dark"
										@click.stop="editData(transaction)"
									></vs-button>
								</vx-tooltip>
								<vx-tooltip
									text="Excel generálás"
									v-if="!transactions[indextr].locked || currentUser.id == transactions[indextr].lockedBy.id"
								>
									<vs-button
										class="btn-drop mr-2"
										type="border"
										icon-pack="feather"
										icon="icon-printer"
										size="medium"
										color="dark"
										@click.stop="printModalOpen(transaction)"
									></vs-button>
								</vx-tooltip>
								<vx-tooltip
									text="Egyebek"
									v-if="!transactions[indextr].locked || currentUser.id == transactions[indextr].lockedBy.id"
								>
									<vs-dropdown
										class="cursor-pointer"
										vs-custom-content
										vs-trigger-click
									>
										<vs-button
											class="btn-drop"
											type="border"
											icon-pack="feather"
											icon="icon-more-horizontal"
											size="medium"
										></vs-button>

										<vs-dropdown-menu class="pt-3 list-more">
											<ul style="min-width: 9rem">

												<li
													v-if="transactions[indextr].lastPhase && transactions[indextr].lastPhase.status == 'done'"
													class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
													@click.stop="addPhase(transaction)"
												>
													<feather-icon
														icon="FolderPlusIcon"
														svgClasses="w-4 h-4"
													/>
													<span class="ml-2">Feladat hozzáadása</span>
												</li>

												<li
													class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
													@click.stop="addSubTransaction(transaction)"
												>
													<feather-icon
														icon="PlusIcon"
														svgClasses="w-4 h-4"
													/>
													<span class="ml-2">Alügylet létrehozása</span>
												</li>

												<li
													class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
													@click.stop="copyTransaction(transaction)"
												>
													<feather-icon
														icon="CopyIcon"
														svgClasses="w-4 h-4"
													/>
													<span class="ml-2">Ügylet másolása</span>
												</li>

												<vs-divider class="m-1" />

												<li
													class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
													@click.stop="closeTransactions(transactions[indextr].id)"
												>
													<feather-icon
														icon="XIcon"
														svgClasses="w-4 h-4"
													/>
													<span class="ml-2">Ügylet lezárása</span>
												</li>

												<li
													class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
													@click.stop="deleteData(transactions[indextr].id)"
												>
													<feather-icon
														icon="Trash2Icon"
														svgClasses="w-4 h-4"
													/>
													<span class="ml-2">Törlés</span>
												</li>

											</ul>
										</vs-dropdown-menu>
									</vs-dropdown>
								</vx-tooltip>

								<vs-dropdown
									v-if="transactions[indextr].locked && (currentUser.id != transactions[indextr].lockedBy.id)"
									vs-custom-content
									vs-trigger-click
									class="cursor-pointer"
								>
									<vs-button
										class="btn-drop"
										type="border"
										icon-pack="feather"
										icon="icon-lock"
										size="medium"
										color="dark"
									></vs-button>

									<vs-dropdown-menu class="pt-3 list-more">
										<h4>
											Ügylet zárolva
										</h4>
										<b>
											Épp szerkeszti:
										</b>
										<p>
											{{ transactions[indextr].lockedBy.fullName }}
										</p>

										<b>
											Szerkesztés kezdete:
										</b>
										<p>
											{{ transactions[indextr].lockedAt }}
										</p>
									</vs-dropdown-menu>
								</vs-dropdown>

							</div>
						</vs-td>
					</vs-tr>
					<vs-tr
						class="sub-table"
						v-if="expandedId == transactions[indextr].id"
						:key="indexSub"
						v-for="(subTransaction, indexSub) in transactions[indextr].subTransactions"
					>
						<vs-td>
						</vs-td>
						<vs-td>
							<router-link
								v-if="!subTransaction.locked || currentUser.id == subTransaction.lockedBy.id"
								:to="/ugylet/ + subTransaction.id"
							>{{ subTransaction.transactionNumber }}</router-link>
							<span v-if="subTransaction.locked && currentUser.id != subTransaction.lockedBy.id">{{ subTransaction.transactionNumber }}</span>
						</vs-td>
						<vs-td :data="subTransaction.taskCode ? subTransaction.taskCode : ''">
							{{ subTransaction.taskCode ? subTransaction.taskCode : '' }}
						</vs-td>
						<vs-td>
							{{ subTransaction.customer ? subTransaction.customer.displayName : '' }}
							<br>
							<small>
								{{ subTransaction.customer ? subTransaction.customer.fullAddress  : '' }}
							</small>
							<br>
							<small>
								{{ subTransaction.contact ? '(' + subTransaction.contact.fullName + ')' : '' }}
							</small>
						</vs-td>
						<vs-td>
							{{ subTransaction.client ? subTransaction.client.displayName : '-' }}
						</vs-td>
						<vs-td>
							{{ subTransaction.property ? subTransaction.property.fullAddress : '' }}
							<br>
							<small>
								HRSZ: {{ subTransaction.property ? subTransaction.property.parcelNumber : '' }}
							</small>
						</vs-td>
						<vs-td>
							{{ subTransaction.transactionType.parent ? subTransaction.transactionType.parent.name + ' / ' + subTransaction.transactionType.name : subTransaction.transactionType.name }}
						</vs-td>
						<vs-td>
							<vs-chip
								v-bind:style="{backgroundColor: transaction.lastPhase.phase.bgColor }"
								v-bind:class="{ darkText: transaction.lastPhase.phase.bgColor == '#fff', darkBorder: transaction.lastPhase.phase.bgColor == '#fff' }"
								color="getStatusColor(subTransaction.lastPhase ? subTransaction.lastPhase.status : '')"
								v-if="subTransaction.lastPhase"
							>
								{{ (subTransaction.lastPhase.phase.id != 1 && subTransaction.lastPhase.phase.id != 7) ? subTransaction.lastPhase.phase.name + ' - ' + subTransaction.lastPhase.statusText : (subTransaction.lastPhase.phase.id == 7 ? subTransaction.lastPhase.phase.name + ' ('  + subTransaction.statusText + ')' : subTransaction.lastPhase.phase.name) }}
								{{ subTransaction.lastPhase.obstacles.length > 0 ? ' - Akadályozott' : '' }}
							</vs-chip>
							<br>
							<br>
							<small>
								Dolgozó: {{ (subTransaction.lastPhase && subTransaction.lastPhase.worker) ? subTransaction.lastPhase.worker.fullName : '' }}
							</small>
						</vs-td>

						<vs-td>
							{{ transaction.orderDate ? transaction.orderDate : '' }} (+{{ transaction.orderDiff ? transaction.orderDiff : '' }})
						</vs-td>
						<vs-td>
							<div class="flex pull-right">
								<vx-tooltip text="Módosítás">
									<vs-button
										class="btn-drop mr-2"
										type="border"
										icon-pack="feather"
										icon="icon-edit"
										size="medium"
										color="dark"
										@click.stop="editData(subTransaction)"
									></vs-button>
								</vx-tooltip>
								<vx-tooltip
									text="Excel generálás"
									v-if="!subTransaction.locked || currentUser.id == subTransaction.lockedBy.id"
								>
									<vs-button
										class="btn-drop mr-2"
										type="border"
										icon-pack="feather"
										icon="icon-printer"
										size="medium"
										color="dark"
										@click.stop="printModalOpen(subTransaction)"
									></vs-button>
								</vx-tooltip>
								<vs-dropdown
									class="cursor-pointer"
									vs-custom-content
									vs-trigger-click
								>
									<vs-button
										class="btn-drop"
										type="border"
										icon-pack="feather"
										icon="icon-more-horizontal"
										size="medium"
									></vs-button>

									<vs-dropdown-menu class="pt-3 list-more">
										<ul style="min-width: 9rem">

											<li
												v-if="transaction.lastPhase && transaction.lastPhase.status == 'done'"
												class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
												@click.stop="addPhase(subTransaction)"
											>
												<feather-icon
													icon="FolderPlusIcon"
													svgClasses="w-4 h-4"
												/>
												<span class="ml-2">Feladat hozzáadása</span>
											</li>

											<vs-divider class="m-1" />
											<li
												class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
												@click.stop="closeTransactions(subTransaction.id)"
											>
												<feather-icon
													icon="XIcon"
													svgClasses="w-4 h-4"
												/>
												<span class="ml-2">Ügylet lezárása</span>
											</li>

											<li
												class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
												@click.stop="deleteData(subTransaction.id)"
											>
												<feather-icon
													icon="Trash2Icon"
													svgClasses="w-4 h-4"
												/>
												<span class="ml-2">Törlés</span>
											</li>

										</ul>
									</vs-dropdown-menu>
								</vs-dropdown>
							</div>
						</vs-td>
					</vs-tr>

				</template>
			</vs-table>
			<vs-pagination
				:total="numberOfPages"
				v-model="currentPage"
			></vs-pagination>
		</vx-card>
	</div>
</template>
<script>
import SubTransactionTable from '@/views/transactions/components/SubTransactionTable.vue'
import Datepicker from 'vuejs-datepicker'
import { hu } from "vuejs-datepicker/src/locale"
import moment from 'moment'
import _ from 'lodash'
import vSelect from 'vue-select'
import { BFormCheckbox } from 'bootstrap-vue'

export default {
	components: {
		SubTransactionTable,
		Datepicker,
		BFormCheckbox,
		'v-select': vSelect,

	},
	data() {
		return {
			printedTransaction: {},
			selectedTransactions: [],
			transactionsCount: 0,
			expandedId: null,
			multipleSelect: false,
			itemsPerPage: 20,
			currentPage: 1,
			numberOfPages: 0,
			transactionTypeModal: false,
			closeTransactionModal: false,
			closeReason: null,
			isMounted: false,
			subTransactionTypeId: '',
			printModal: false,
			addPhaseModal: false,
			searchModal: false,
			selectAllTransactions: false,
			search: {
				itemsPerPage: 20,
				customer: null,
				transactionType: null,
				transactionPhases: [],
			},
			transactions: null,
			errorMessage: this.$route.params.error,
			searchData: null,
			phases: null,
			workers: null,
			subTransaction: {},
			newPhase: {},
			langHu: hu,
			showOnlyDeficient: this.$route.fullPath == '/ugyletek' ? true : false
		}
	},
	computed: {

	},
	watch: {
		subTransactionTypeId() {
			let type = this.searchData.transactionTypes.find(e => e.id == this.subTransactionTypeId)
			this.subTransaction.type = type
		},
		currentPage() {
			this.search.currentPage = this.currentPage
			this.search.itemsPerPage =  this.itemsPerPage

			if(typeof this.search.customer == 'object' && this.search.customer[0]) {
				this.search.customer = this.search.customer[0].id
			}
			let queryString = '?'
			queryString += '&' + Object.keys(this.search).map(key => key + '=' + this.search[key]).join('&');

			history.replaceState(null, '', '/ugyletek' + queryString);

			if(this.showOnlyDeficient) {
				this.getDeficientTransactions(this.search)
			} else {
				this.getTransactions(this.search);
			}

		},
		selectAllTransactions() {
			console.log(this.selectAllTransactions);

			this.selectedTransactions = []

			if(this.selectAllTransactions) {
				this.transactions.forEach(transaction => {
					this.selectedTransactions.push(transaction.id)
				});
			}

			console.log(this.selectedTransactions);
			console.log('all selected change');
		},
		showOnlyDeficient() {
			if (this.showOnlyDeficient) {
				this.getDeficientTransactions(this.search)
			} else {
				this.getTransactions(this.search);
			}
		}
	},
	methods: {
		customFormatter(date) {
			return moment(date).format('YYYY.MM.DD.');
		},
		dateformatForBackend(date) {
			if(date && date !== '' && date !== null) {
				return moment(date).format('YYYY-MM-DD');
			} else {
				return ''
			}
		},
		fetch(filters = null) {	
			let queryString = ''

			this.$vs.loading()

			if(filters && !filters.currentPage && !filters.itemsPerPage) {
				queryString += '?currentPage=' + filters.currentPage + '&itemsPerPage=' + filters.itemsPerPage
			} else {
				queryString += '?'
			}

			if (filters) {

				filters.startDate = this.dateformatForBackend(this.search.startDate)
				filters.endDate = this.dateformatForBackend(this.search.endDate)

				if(filters.customer && !Number.isInteger(filters.customer) && filters.customer.length > 0) {
					filters.customer = filters.customer[0].id
				}

				if(filters.transactionType && !Number.isInteger(filters.transactionType) && filters.transactionType.length > 0) {
					filters.transactionType = filters.transactionType[0].id
				}

				queryString += '&' + Object.keys(filters).map(key => key + '=' + filters[key]).join('&');

				history.replaceState(null, '', '/ugyletek' + queryString);
				
				this.search = this.$route.query

				// this.$router.replace({
				// 	path: '/ugyletek',
				// 	query: {
				// 		currentPage: this.currentPage,
				// 		itemsPerPage: this.itemsPerPage,
				// 		customer: filters.customer,
				// 		param1: Math.random()
				// 	},
				// });


			} else {
				this.search.customer = null
				this.search.client = ''
				this.search.property = ''
				this.search.parcelNumber = ''
				this.search.taskCode = ''
				this.search.transactionNumber = ''
				this.search.transactionType = null
				this.search.startDate = null
				this.search.endDate = null
				this.search.transactionPhase = ''
				this.search.currentPage = 1
				this.search.itemsPerPage = 20
				history.replaceState(null, '', '/ugyletek');
			}
			this.$vs.loading.close()
			
			this.getTransactions(this.search)

			
		},
		getDeficientTransactions(search) {
			this.$vs.loading()

			this.search.client = ''
			this.search.property = ''
			this.search.parcelNumber = ''
			this.search.taskCode = ''
			this.search.transactionNumber = ''
			this.search.transactionType = null
			this.search.startDate = null
			this.search.endDate = null
			this.search.transactionPhase = ''

			search.itemsPerPage = search.itemsPerPage ? search.itemsPerPage : this.itemsPerPage
			search.currentPage = search.currentPage ? search.currentPage : this.currentPage

			this.currentPage = search.currentPage ? parseInt(search.currentPage) : this.currentPage
			this.itemsPerPage = search.itemsPerPage ? parseInt(search.itemsPerPage) : this.itemsPerPage

			let queryString = '?'
			if(!_.isEmpty(search)) {
				queryString += '&' + Object.keys(search).map(key => key + '=' + search[key]).join('&');
			}

			this.$http.get('/api/transactions/list-deficient/' + queryString)
				.then((response) => {
					this.transactions = response.data.data
					// if (this.search.transactionPhase && this.search.transactionPhase != 'all') {
					// 	this.transactions = this.transactions.filter(tr => tr.lastPhase.phase.id == this.search.transactionPhase);
					// }
					this.currentUser = JSON.parse(localStorage.getItem('userInfo'))
					this.numberOfPages = Math.ceil(response.data.sum / this.itemsPerPage);
					this.transactionsCount = response.data.sum;
					this.$vs.loading.close()
				})
				.catch(() => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Hiba',
						text: 'Elnézést! A rendszer hibába ütközött.',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
				})
		},
		getTransactions(search) {
			this.showOnlyDeficient = false
			search.itemsPerPage = search.itemsPerPage ? search.itemsPerPage : this.itemsPerPage
			search.currentPage = search.currentPage ? search.currentPage : this.currentPage

			this.currentPage = search.currentPage ? parseInt(search.currentPage) : this.currentPage
			this.itemsPerPage = search.itemsPerPage ? parseInt(search.itemsPerPage) : this.itemsPerPage

			this.$vs.loading()

			let queryString = '?'
			if(!_.isEmpty(search)) {
				queryString += '&' + Object.keys(search).map(key => key + '=' + search[key]).join('&');
			}
			this.$http.get('/api/transactions/list/' + queryString)
				.then((response) => {
					this.transactions = response.data.data
					// if (this.search.transactionPhase && this.search.transactionPhase != 'all') {
					// 	this.transactions = this.transactions.filter(tr => tr.lastPhase.phase.id == this.search.transactionPhase);
					// }
					this.currentUser = JSON.parse(localStorage.getItem('userInfo'))
					this.numberOfPages = Math.ceil(response.data.sum / this.itemsPerPage);
					this.transactionsCount = response.data.sum;
					this.$vs.loading.close()
				})
				.catch(() => {
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Hiba',
						text: 'Elnézést! A rendszer hibába ütközött.',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
				})
		},
		addNewData() {
			this.$router.push('/ugyletek/uj')
		},
		addSubTransaction(transaction) {
			this.fetchSearchData()
			this.transactionTypeModal = true
			this.subTransaction.mainTransactionId = transaction.id
			this.fetch()
		},
		addPhaseMultiple() {
			this.addPhaseModal = true
			this.newPhase.transactionId = this.selectedTransactions
			this.fetchPhases()
			this.fetchWorkers()
		},
		addPhase(transaction) {
			this.addPhaseModal = true
			this.newPhase.transactionId = transaction.id
			this.fetchPhases()
			this.fetchWorkers()
		},
		searchModalOpen() {
			this.searchModal = true
		},
		fetchPhases() {
			this.$http.get('/api/phases/list')
				.then((response) => {
					this.phases = response.data.data
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		fetchWorkers() {
			this.$http.get('/api/users/list')
				.then((response) => {
					this.workers = response.data.data
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		fetchSearchData() {
			this.$http.get('/api/transactions/search-data')
				.then((response) => {
					this.searchData = response.data
					this.search.customer = this.searchData.customers.filter(tr => tr.id == this.search.customer);
					this.search.transactionType = this.searchData.transactionTypes.filter(tr => tr.id == this.search.transactionType);
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		savePhase() {
			this.$http.post('/api/transactions/phase/add', this.newPhase)
				.then(() => {
					this.fetch()
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.addPhaseModal = false
					this.selectedTransactions = []
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		saveSubTransaction() {
			this.$http.post('/api/transactions/create/sub', this.subTransaction)
				.then((response) => {
					this.fetch()
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.searchData = response.data.data
					this.transactionTypeModal = false
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		deleteData(id) {
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: `Biztosan törlöd az adatot?`,
				acceptText: 'IGEN, törlöm',
				cancelText: 'mégsem',
				accept: this.confirmDelete,
				parameters: id
			})
		},
		confirmDelete(id) {
			this.$http.delete('/api/transactions/delete/' + id).then(() => {
				this.$vs.notify({
					title: 'Siker',
					text: 'Sikeres törlés',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'success',
					position: 'bottom-center'
				})
				this.fetch();
			}).catch(err => { console.error(err) })
		},
		editData(data) {
			this.$router.push('/ugylet/' + data.id)
		},
		printModalOpen(transaction) {
			this.printedTransaction = transaction
			this.printModal = true
		},
		printData(data) {
			this.$vs.loading()
			this.$http.post('/api/transactions/export', { transaction: data })
				.then((response) => {
					const url = response.data.filePath
					const link = document.createElement('a')
					link.href = url
					link.setAttribute('download', response.data.fileName)
					document.body.appendChild(link)
					link.click()
					this.$vs.loading.close()
					this.printModal = false
				})
				.catch((error) => {
					// console.log(error);
					this.showError(error)
					this.$vs.loading.close()
					this.printModal = false
				})
		},
		// filterTransactions(search) {


		// 	this.fetch(search)
		// },

		filterDates(search) {
			if(search.startDate && search.endDate) {
				this.filterTransactions(search)
			}
		},
		filterTransactions: _.debounce(function () {
			this.currentPage = 1
			this.fetch(this.search)
			this.searchModal = false
		}, 500),
		getStatusColor(status) {
			switch (status) {
				case 'in_progress':
					return 'warning'

				case 'done':
					return 'success'

				case 'obstacle':
					return 'danger'

				default:
					return 'dark'
			}
		},
		orderTransactions(sortBy) {
			this.search.sortBy = sortBy
			this.search.sortDir = this.search.sortDir == 'asc' ? 'desc' : 'asc'
			this.fetch(this.search)
		},
		closeTransactions(transactionId = null) {
			if (transactionId) {
				this.selectedTransactions.push(transactionId)
			}

			if (this.selectedTransactions.length < 1) {
				this.$vs.notify({
					time: 4000,
					title: 'Hiba',
					text: 'Nincs kiválasztva ügylet',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'danger',
					position: 'bottom-center'
				})
			} else {
				this.closeTransactionModal = true
			}
		},
		confirmCloseTransaction() {
			this.$http.post('/api/transactions/close', { transactions: this.selectedTransactions, reason: this.closeReason })
				.then(() => {
					this.fetch()
					this.closeTransactionModal = false
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres művelet',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		copyTransaction(transaction) {
			this.$http.post('/api/transactions/copy', { transactionId: transaction.id })
				.then((response) => {
					this.$router.push('/ugylet/' + response.data.data.id)
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres művelet',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
				})
				.catch((error) => {
					this.showError(error)
				})
		},
		expandSubRows(transactionId) {
			if (this.expandedId == transactionId) {
				this.expandedId = null
			} else {
				this.expandedId = transactionId
			}
		},
		showError(error) {
			this.$vs.loading.close()
			this.$vs.notify({
				time: 8000,
				title: 'Hiba',
				text: 'Elnézést! A rendszer hibába ütközött. <br> --- <br>' + error,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger',
				position: 'bottom-center'
			})
		}
	},
	created() {
		this.search = this.$route.query
		if(this.showOnlyDeficient) {
			this.getDeficientTransactions(this.search)
		} else {
			this.getTransactions(this.search)
		}
		this.fetchSearchData()

		if (this.errorMessage) {
			setTimeout(() => {
				this.errorMessage = null
			}, 8000);
		}
	},
	mounted() {
		this.isMounted = true;
	}
}
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 0rem;
			margin-right: 0rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 10px;
				}
				td.td-check {
					padding: 10px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				background-color: #fff;
				padding-top: 10px;
				padding-bottom: 10px;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}

		.vs-table--content {
			margin-top: 20px;
		}
	}

	.con-tablex.vs-table--content, .vs-con-table .vs-con-tbody {
		overflow: visible;
	}
}
</style>
